const SK_WAVE_CLIENT_ID = "wave.clientId";

let cachedClientId: string | null = null;

/** Stable per browser tab/session for Wave presence multi-device tracking. */
export function waveSessionClientId(): string {
  if (cachedClientId) return cachedClientId;
  try {
    const stored = sessionStorage.getItem(SK_WAVE_CLIENT_ID);
    if (stored && stored.trim().length > 0) {
      cachedClientId = stored;
      return stored;
    }
    const created = crypto.randomUUID();
    sessionStorage.setItem(SK_WAVE_CLIENT_ID, created);
    cachedClientId = created;
    return created;
  } catch {
    const fallback = crypto.randomUUID();
    cachedClientId = fallback;
    return fallback;
  }
}
